"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserSpecificNotificationListResponse = exports.UserSpecificNotificationListResponseSchema = void 0;
const user_specific_notification_types_1 = require("../models/user_specific_notification_types");
exports.UserSpecificNotificationListResponseSchema = user_specific_notification_types_1.UserSpecificNotificationEntrySchema.array();
const isUserSpecificNotificationListResponse = (x) => exports.UserSpecificNotificationListResponseSchema.safeParse(x).success;
exports.isUserSpecificNotificationListResponse = isUserSpecificNotificationListResponse;
//# sourceMappingURL=user_specific_notification_args.js.map